const Data = [
 {
   "id": 1,
   "peopleid": 1,
   "title": "10 Star Home",
   "address": "Cape Paterson, VIC",
   "desc": "As Victoria’s first 10-star energy rated home, this timber-clad residence is at the forefront of sustainable housing in the state. Designed by The Sociable Weaver and Clare Cousins Architects, the house was also the state’s first home to be carbon positive and built to a zero-waste philosophy, with just three bags of rubbish sent to landfill during construction. It costs an estimated $3 a year to run, not requiring any mechanical heating or cooling thanks a passive-solar design that allows for cross ventilation. The green machine is used as a display home at The Cape eco village in Victoria’s southeast. It’s for sale for $590,000 and can be built anywhere in metro Melbourne, the Mornington Peninsula and Gippsland. Plans for the home can also be downloaded for free from liveatthecape.com.au. Pictures: Dan Hocking, Jason Edwards",
   "imagename1": "1-1",
   "imagename2": "1-2",
   "imagename3": "1-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 2,
   "peopleid": 2,
   "title": "The Farm",
   "address": "Illawarra, NSW",
   "desc": "Architect Fergus Scott said this home was designed to encourage the owners and visitors to the home to physically experience the landscape, a big ask considering the weather extremes experienced on the NSW south coast. But an aim, as you can see with this home that defies superlatives, that as more than achieved. Its vision and design has managed to match the incredible beauty of the Australian coastline but also to provide a comfortable, awe-inspiring and visceral living experience to match the physical environment where the intensity of the summer heat is equally by the ferocity of winter storms, while becoming part of the landscape itself. All above ground external walls are rammed earth, exposed in the house to provide an earthy feel, winning it the 2016 MBA Excellence in Housing Awards. Winner Best Use of Rammed Earth award. Hydronic heating is installed throughout the home which houses onsite sewage treatment plant. Pictures: Fergus Scott Architects",
   "imagename1": "2-1",
   "imagename2": "2-2",
   "imagename3": "2-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 3,
   "peopleid": 3,
   "title": "Vanquish",
   "address": "Auchenflower, QLD",
   "desc": "Vanquish does for sustainable housing what the first humans on the moon did for space exploration. It sets a high benchmark, one that may not be repeated often but is proof that a large-scale Passive House can be built in subtropical Queensland without missing out on the outdoor lifestyle we know and love. Vanquish has been built by local Brisbane company Solaire Properties and features hyper-efficient insulation, an airtight membrane, triple glazing and high-performance ventilation. It can maintain a constant temperature of 23 degrees and delivers air that is cleaner inside the house than outside, perfect for anyone with allergies. With all the windows and doors closed, no outside noise penetrates, making Vanquish the most whisper-quiet home we have ever entered. There are enough solar panels and batteries for near zero energy usage and the home is set up with Control4 home automation. We think it’s a green leader. Pictures: Brock Beazley, Solaire Properties\n",
   "imagename1": "3-1",
   "imagename2": "3-2",
   "imagename3": "3-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 4,
   "peopleid": 4,
   "title": "Carbon package",
   "address": "Campbelltown, SA",
   "desc": "When it comes to green housing. Carbon’s a big deal. Or the lack of it, rather. That’s where this place comes into its own. TS4’s zero carbon house – an SA government initiative – in Campbelltown’s Lochiel Park, one of SA’s first sustainable housing development, is, as it’s title suggests, zero carbon. Care was taken to minimise the carbon used during construction and the home has been calculated to become carbon neutral by 2045. Put simply, all of the carbon generated creating the materials, building and transport and shipping of materials, plus all of the operational energy needed to heat and cool the home will be offset by the energy exported from the solar system. You’ve got to admit, that’s pretty clever indeed …",
   "imagename1": "4-1",
   "imagename2": "4-2",
   "imagename3": "4-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 5,
   "peopleid": 5,
   "title": "Plane Tree House",
   "address": "Glen Osmond, SA",
   "desc": "Plane Tree House is more than just an impressive modern home with breathtaking views – it has been designed to stand the test of time with an emphasis on environmental sustainability. The four-bedroom Glen Osmond home, which was inspired by Japanese architect Tadao Ando and designed by local talent Architects Ink, is an energy efficient and hi-tech home. Its standout features include 43,000L of rainwater storage, fully automated blinds and an exterior solar shading system that is, again, fully automated. One of the home’s most impressive features though is the large plane tree, its namesake, which was incorporated into its design. It offers shade in summer and then when the leaves drop in winter, the house benefits from the full easterly sun.",
   "imagename1": "5-1",
   "imagename2": "5-2",
   "imagename3": "5-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 6,
   "peopleid": 6,
   "title": "The Seed House",
   "address": "Castlecrag, NSW",
   "desc": "Architect James Fitzpatrick, of Fitzpatrick and Partners poured his heart and soul into the design of what would become known as The Seed House. After all he was designing the home for his own young family, on a prime site of more than 5000sqm at Castlecrag, on Sydney’s upper north shore. The landmark home took more than two years to build and features extensive use of cross-laminated timber (CLT) in a series of interconnected, cantilevered structural pods that are home to a rich array of Tasmanian timbers, including Huon pine, blackwood and celery top pine, all reportedly collected during the space of more than a decade. The shells fall with the natural slope of the land and make the most of the Middle Harbour and Sugarloaf Hill views. Mr Fitzpatrick described the home as an “experimentation in construction and engineering”, but one that is also a “forever home” for a young family. “It will adapt and change as they do, forever.” The Seed House won the prestigious Excellence in Timber Design award at the 2019 Australian Timber Design Awards.",
   "imagename1": "6-1",
   "imagename2": "6-2",
   "imagename3": "6-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 7,
   "peopleid": 7,
   "title": "Recyclable House",
   "address": "Beaufort, VIC",
   "desc": "This striking home in Victoria’s west is believed to be the nation’s only almost completely recyclable house. This puts it well ahead of typical Aussie abodes, which are usually only about 20 per cent recyclable. Inquire Invent managing director Quentin Irvine was inspired by Australia’s iconic steel woolsheds when he designed and built the home, which was completed in 2015. It’s made of recyclable materials that were screwed and nailed together, and incorporates solar-passive principles to keep the house cool in summer and warm during Beaufort’s harsh winters. According to the Sustainable House Day website, the house’s “experimental closed-loop design and construction methodologies” set it apart. This method rejects the traditional linear model of “make, use and dispose” to feed the disposal stage back into the new product. Holiday-makers can rent the eco getaway for $280 per night on Airbnb. Pictures: Nic Granleese",
   "imagename1": "7-1",
   "imagename2": "7-2",
   "imagename3": "7-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 8,
   "peopleid": 8,
   "title": "Domic",
   "address": "Sunshine Beach, QLD",
   "desc": "The vision of hemp industrialist, Evgeny Skigin, ‘Domic’ is a breathtaking product of an uncompromising passion and drive for sustainable living. This six-bedroom, nine-bathroom home is made up of a series of shell-like domes, that blend into the natural landscape on the edge of Noosa National Park and the world-famous Sunshine Beach. Its eco-friendly design is reflected in the use of clever landscape architecture and innovative building materials and efficiencies such as Hempcrete thermal walls, solar performing glass, natural ventilation systems, a 5kw-plus solar system, 126Kwh of battery storage, 30,000 litres of water storage and a roof garden for thermal performance. Among other awards, the unique property won House of the Year at the 2020 Master Builders Queensland Housing & Construction Awards,",
   "imagename1": "8-1",
   "imagename2": "8-2",
   "imagename3": "8-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 9,
   "peopleid": 9,
   "title": "Hart House",
   "address": "Great Mackerel Beach, NSW",
   "desc": "The Hart House at Great Mackerel Beach was designed by Rob Brown and Carly Martin of Casey Brown Architecture for Nick and Louisa Hart after they paid $900,000 to buy entrepreneur Sam Ballas’s 630sqm building block in 2014. Last year they sold the modern interpretation of the classic Australian beach shack, located 10m from Great Mackerel Beach, for an impressive $3.3 million. The result was only $100,000 shy of equalling the suburb’s sale price record, set in 2006. Great Mackerel Beach is on the shores of Pittwater and accessible only by boat, and is home to less than 125 properties. The Casey Brown design ¬for the Hart House delivers the illusion from inside that the house is floating on the water, while the rear has views of the bush landscape. Small side openings allow for further cross ventilation of the corrugated aluminium shell. Colours reflect the beach and bush landscape. The shell protects the house from the harsh salt environment, cold winter southerly winds and bushfire prone landscape.",
   "imagename1": "9-1",
   "imagename2": "9-2",
   "imagename3": "9-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 10,
   "peopleid": 10,
   "title": "MM House",
   "address": "Northcote, VIC",
   "desc": "Hundreds of people have been wowed by this eco wonder – which EME Design director Luke Middleton built for himself and his family – at open homes on consecutive Sustainable House Days. The four-bedroom house has achieved eight stars on the NatHERS (Nationwide House Energy Rating Scheme) and 10 stars on the Victorian Residential Efficiency Scorecard. It’s all-electric, follows passive-house principles and features a 5kW solar system to run carbon positive – and on top of that, export about 3500kW of electricity annually. EME Design’s website states the house, made from rammed earth and timber, is also doing its part for the next generation of sustainable design as an “ongoing experiment testing the air quality and temperature, energy output, rainwater collection, and adaptability for future use”. The monitoring found during winter, only minimal heating through a fireplace using locally sourced wood was required. And in summer, the home’s temperature was lowered passively through natural ventilation, a heat-recovery ventilation system, insulation and thermal mass. Pictures: Peter Clarke, Luke Middleton",
   "imagename1": "10-1",
   "imagename2": "10-2",
   "imagename3": "10-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 11,
   "peopleid": 11,
   "title": "The Long House",
   "address": "Tamborine Mountain, QLD",
   "desc": "This sustainable home, known as the Long House, is nestled among the trees of Mount Tamborine in the Gold Coast hinterland, and has featured in an episode of the Channel 9 series Grand Designs Australia. A passion project for owners James and Sarah Hobart, it was built from locally sourced materials, chosen for their expected 50-plus-years life-span. Despite having a large block, the Hobarts kept the footprint restrained at less than 200 sqm. According to the architect, James Russell, houses should be no bigger than this if someone is genuine about minimising material use and being economically sustainable. Long Road is predominantly run on passive heating and cooling, assisted by bulk insulation in the walls, floors and roof. A screen envelopes the courtyard and one side of the building, which is orientated to capture the breezes, while heavily insulated walls with small openings deflect adverse conditions on the other. Roof water is stored in a 36,000l inground tank, while ground water is filtered through a reedbeds into a retention pond for watering fruit and vegetable gardens onsite.",
   "imagename1": "11-1",
   "imagename2": "11-2",
   "imagename3": "11-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 12,
   "peopleid": 12,
   "title": "Through the Looking Glass home",
   "address": "Hazelwood Park, SA",
   "desc": "A striking, angular glass house built on a property with a natural creek running through it and established River Red gum trees around it, has sustainability at its heart. A renovation of a 1950s home, designed by John Adam Architects, added walls of glass, quirky angles and reflective surfaces to connect with the natural environment, which includes a pond and native garden. Inside, sustainable design principles were implemented to regulate the home’s temperature with the brief to open up the house and make the garden more accessible to the interior. The extension cleverly wraps around mature trees and follows the creek bed with a two-storey-high area and a cantilevered retreat room that looks over it. The project, called Through the Looking Glass, won the architect an award for Residential Architecture – Houses (Alterations and Additions) at the 2020 South Australian Architecture Awards.",
   "imagename1": "12-1",
   "imagename2": "12-2",
   "imagename3": "12-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 13,
   "peopleid": 13,
   "title": "Coast",
   "address": "Cape Paterson, VIC",
   "desc": "Annual energy bills are close to zero at this 8.1-star energy rated home, which showcases the best of carbon neutral Australian housing. Designed by Adam Dettrick Architects and built by TS Constructions, this four-bedroom home at The Cape in Victoria’s southeast essentially doubles as a clean-energy power and petrol station. It generates a large surplus of clean energy each year, features efficient all-electric appliances and has 32 amp charge points for electric vehicles. Excellent passive-solar design is achieved via strategic shading, double glazing, thermal mass, insulation and cross-flow ventilation, while the double-storey home is also solar powered. The property is a productive farm too, thanks to landscaping by The Sustainable Landscape Company, connected to a 10,000 litre rainwater tank and producing more than 500kg of fresh produce each year.",
   "imagename1": "13-1",
   "imagename2": "13-2",
   "imagename3": "13-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 14,
   "peopleid": 14,
   "title": "Sunken Treasure",
   "address": "Clayfield QLD",
   "desc": "Commended by the Australian Institute of Architects for its clever eco-adaptability to tropical climates, this entire home focuses around a private, sunken internal courtyard. Completely hidden from street level, the internal garden allows not only for total privacy, but a tranquil outlook from a number of internal and outdoor living spaces. Designed by architect James Russell, the award-winning home embraces a minimalist design with the use of natural materials such as stone, concrete and marble. Russell transformed what was originally a red brick spec home into a clever, contemporary masterpiece - using many of the original materials. Similar brick was used in the home's alterations, and while it's clear where new work has occurred, it is also sympathetic with the existing house. The courtyard replaces what used to be a concrete driveway - creating a beautiful green meadow in the centre of the home. Rooms open completely to the courtyard thanks to large sliding doors, allowing the house to become part of the landscape and the landscape part of the house. The bright, white kitchen also opens to the courtyard and the backyard, creating the perfect indoor/outdoor living arrangement for Brisbane's subtropical climate. According to the architect, living there is now about re-engaging with the landscape through a series of connected spaces.",
   "imagename1": "14-1",
   "imagename2": "14-2",
   "imagename3": "14-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 15,
   "peopleid": 15,
   "title": "Sustainable Haven",
   "address": "Queens Park, NSW",
   "desc": "Owner and architect Steven Gerendas spent 10 years designing and building this amazing home which is just minutes from Bondi Junction shopping district but a world away. The $8m home is striking but in tune with its natural surrounds including the sheer rock face it sits beside, on the site of an old quarry. Passive solar design ensures contemporary maintenance-free living that rarely requires heating or cooling. The piece de resistance of this 4-level home is its wing roof, complete with a landscaped zen garden that blends into the treetops and not to forget the recycled hardwood staircase.",
   "imagename1": "15-1",
   "imagename2": "15-2",
   "imagename3": "15-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 16,
   "peopleid": 16,
   "title": "Bundeena Beach House",
   "address": "Bundeena, NSW",
   "desc": "Located in a private spot near a beach in the Royal National Park, this project had a particular focus on the environment and its surrounds, as well as how the home connects to the landscape. The house is 'nestled' into the land, while the roof forms part of a 'green infinity edge' to the water. Nominated for a number awards and designed by Grove Architects, the home is made from timber and weathering steel and has an unassuming street presence yet incredible design. Picture: Michael Nicholson/Grove Architects",
   "imagename1": "16-1",
   "imagename2": "16-2",
   "imagename3": "16-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 17,
   "peopleid": 17,
   "title": "Mornington Glory",
   "address": "Balhannah, SA",
   "desc": "When it comes to green living, it doesn’t come much more spectacular than this. Winning several HIA awards including 2011’s Home Of The Year and Energy Efficient Home, Mornington Rise also holds the title of being the most expensive home sold in the Adelaide Hills, fetching its seller a whopping $5.5 million. It’s clear you get one heck of an entertainer’s lifestyle with that. But that money also buys you a clean conscience, knowing you’re doing your part for the planet. This place is packed with green features, not limited to its 6-star energy rating, 10kw solar system, double-glazed Argon gas-filled windows, rammed-earth construction slow combustion heater with ample wood supply on-site and underfloor heating throughout. That’s one heck of a list!",
   "imagename1": "17-1",
   "imagename2": "17-2",
   "imagename3": "17-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 18,
   "peopleid": 18,
   "title": "Biophilia - Slate House",
   "address": "Northcote, VIC",
   "desc": "The pool remarkably works as a “battery” at this solar-powered, all-electric Melbourne Design Studios creation. The same goes for an innovative slab heating and cooling system, which the architecture firm describes on its website as performing “natural ‘battery’ storage” by passively storing heat in winter and actively storing “coolth” in summer. Integrated home automation enhances the home’s sustainability, including through automated external blinds and an alarm that goes off when the air conditioner is switched on while windows are open. Passive-solar design has also been integrated into the home, in the form of thermal mass, north eaves, cross ventilation, strategic shading, and a “highly insulated and airtight building shell”. And it was built with sustainably sourced materials like recycled bricks. The project, created from 2016-18, won the NABD’s Best Sustainable Design in Australia and Design Matters Awards’ Best New House in Victoria and Best Environmentally Sustainable Design gongs in 2019, while being a finalist for several other awards.",
   "imagename1": "18-1",
   "imagename2": "18-2",
   "imagename3": "18-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 19,
   "peopleid": 19,
   "title": "NEAThouse",
   "address": "Dodges Ferry, TAS",
   "desc": "Jane and Owen Thomson of NEAThouse set a benchmark in the industry with their award-winning timber houses. Using the right materials and an efficiency of design is the key to what they do. They source the timber from plantations or reclaim it from farm windbreaks. In this eight-star Dodges Ferry house, the NEAT team also used macrocarpa cladding, pine interior wall linings and eco-plywood walls. All of the timber finishes use super-low VOC (volatile organic compound) oils. From low-energy LED lights to the rainwater harvesting, double-glazed thermally broken windows to the insulation in the walls, ceiling, roof and under floors, this home ticks every green box. Pictures: Natalie Mendham",
   "imagename1": "19-1",
   "imagename2": "19-2",
   "imagename3": "19-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 20,
   "peopleid": 20,
   "title": "The Upside Down Akubra House",
   "address": "Tamworth, NSW",
   "desc": "Hats off to the team who designed this off-the-grid home in country NSW. The large skillion roof with solar panels was inspired by an Akubra hat and powers the house. The unique roof also insulates the home from extreme temperatures and, by channelling rainwater, keeps it self-sufficient. Constructed by Blue Eco Homes and designed by architect Alexander Symes, the structure known as the Upside Down Akubra House is the winner of multiple architecture awards. It was designed to celebrate the unique landscape and vistas of the surrounding landscape near Tamworth. The living spaces sit on the perimeter of the home, while a compact service core is at the centre.",
   "imagename1": "20-1",
   "imagename2": "20-2",
   "imagename3": "20-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 21,
   "peopleid": 21,
   "title": "Cyclone survival",
   "address": "Darwin, NT",
   "desc": "Sustainable living in the tropics. A tremendous example of a brilliant renovation project from an environmentally conscious Darwin family. Winner of the 2019 HIA Australian GreenSmart Renovation/Addition Project, the judges commented: ‘this home is an example of very clever energy management’. The external wall cladding has high solar reflectant properties, louvres and wooden, glass panelled doors allow a great flow of breeze and water is pumped, treated and then gravity fed back to the house. In the garden sits a Tamarind tree that survived both Cyclone Tracy and Cyclone Marcus. Pictures: HIA",
   "imagename1": "21-1",
   "imagename2": "21-2",
   "imagename3": "21-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 22,
   "peopleid": 22,
   "title": "Solis",
   "address": "Hamilton Island, QLD",
   "desc": "This free-flowing home was designed by the internationally recognised Sydney architect Renato D’Ettorre and it won its fair share of awards after it was completed in 2010, including the highly coveted Australian Institute of Architects’ National Award for Residential Architecture. While almost a decade has passed, this house sculpted from concrete, stone and glass is as relevant today as when it was first built. With airy living spaces and private sheltered outdoor zones, corners of the home float above the terraced landscape. Set on 3,234sqm of waterfront land on Hamilton Island, the gateway to the world-heritage listed Great Barrier Reef, Solis is a fantastic example of timeless architecture. And you are spoiled for choice when it comes to pools, the house has three. The largest envelopes the entire ground floor, giving the perception that the house flows effortlessly into the Coral Sea.",
   "imagename1": "22-1",
   "imagename2": "22-2",
   "imagename3": "22-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 23,
   "peopleid": 23,
   "title": "Future-proof Home",
   "address": "Adelaide, SA",
   "desc": "When this house was built in 2014, the owners, former SA environment minister John Hill and his wife Andrea, had a specific brief: they wanted a house that they could live in as they got older, which was environmentally and socially sustainable, and aesthetically pleasing. The result is an attractive, contemporary zoned home built on a 455sqm block with a north-facing living area that catches abundant natural light. A 25,000 rainwater tank, built under the driveway, is fed by a water catchment system from the roof and is used for the toilets, laundry and garden irrigation. A productive garden has at least 20 fruit trees and six raised vegie beds - with something picked from the garden in almost every meal served. Retractable 50 per cent shade cloth screens are used in summertime to protect crops. The home was constructed with Hebel panels for both insulation value and aesthetics, solar panels on the roof reduce power bills while underfloor heating in the concrete floor keeps them warm in winter. A mass of insulation in thick walls regulates the internal temperature while fans, low-energy lighting, skylights, louvre windows for passive crossflow ventilation are other inclusions. Mindful long-term sustainability features such as cavity doors to reduce noise and zone parts of the home, keeping floor levels the same throughout, wider doorways to suit frames and wheelchairs, and ensuring abundant light to reduce the chance of falls were further sustainable, future-proofing choices. Choosing to build near good public transport links and a village-like shopping strip were other conveniences that merit this home with long-term sustainability for this semi-retired family.",
   "imagename1": "23-1",
   "imagename2": "23-2",
   "imagename3": "23-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 24,
   "peopleid": 24,
   "title": "Dreamcatcher'",
   "address": "Cairns, QLD",
   "desc": "This award-winning, sustainable home is called Dreamcatcher, and it is perched on top of a hill surrounded by mountains and rainforest near Cairns. The pavilion-style home is set around a five-pointed stone circle to form a dreamcatcher from above. Each pavilion uses recycled timber from the old Cairns Wharf and glass elements, courtyards, water and landscaping. The property was a “labour of love” for its creators Sophie and Andrew Barrett of Cairns building consulting firm Green at Heart. The roof has vented eaves, solar ridge vents, double insulation and 900mm overhangs to keep the residence cool year-round, and the structure is lightweight, minimizing construction waste. Designed to make the most of cross-ventilation, plus the use of skylights and the use of light colours to reflect the heat, this cool house is perfect for the tropical summer. Sustainability was at the heart of the build, with recycled crushed glass used under the slabs instead of sand, and all construction waste was recycled where possible. The house features a 5.6kW battery compatible solar power system, solar hot water, energy efficient appliances and LED lighting throughout. Outside there is recycled timber, low water use gardens, bespoke polished concrete pavers with recycled glass, composting, green walls, a rainwater tank and a low chemical magnesium pool. It has a 9.5 star energy rating and has an estimated saving of $4000 a year, and the family still call the iconic residence home.",
   "imagename1": "24-1",
   "imagename2": "24-2",
   "imagename3": "24-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 25,
   "peopleid": 25,
   "title": "Davison Street Collaborative",
   "address": "Brunswick, VIC",
   "desc": "Three groups of built environment professionals — Archier director Chris Gilbert, HIP V HYPE directors Liam Wallis and Katya Crema, and sustainability consultant Peter Steele — pooled their resources and experience in architecture, sustainability and project management to create three sustainable townhouses on a single Melbourne block for themselves. The homes have 8-star energy ratings as a result of passive-design principles, solar panels and batteries, an energy-recovery ventilation system, electric heat pumps for hot water, and hydronic heating. Recycled materials were used where possible for the project, completed in 2020, which followed a “Collaborative Development” model described as a “solution to the problem of sky-high Melbourne property prices” on the Archier website. The development is a finalist in the Houses Awards 2021 sustainability and new houses under 200sq m categories. Pictures: Tess Kelly",
   "imagename1": "25-1",
   "imagename2": "25-2",
   "imagename3": "25-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 26,
   "peopleid": 26,
   "title": "5x4 House",
   "address": "East Melbourne, VIC",
   "desc": "The house dubbed Melbourne’s “mini skyscraper” by Grand Designs Australia is “25 per cent more efficient than the average Australian home, despite having a hot tub and 75 per cent more glass than the average home”, according to owner-builder Ralph Alphonso. The floor-to-ceiling windows are double glazed and dressed with external blinds that are automated to open and close at certain times of day, to ensure the home takes in natural light without overheating. And the building’s energy efficiency — which was studied by the University of Melbourne — is further boosted by quality insulation, an airtight build and a geothermal source heat pump. Mr Alphonso also created the four-level pad to be no bigger than he, his partner and his dog needed, on a 20sq m plot of land. As Grand Designs host Peter Maddison said: “It’s completely passive (and) the architecture is pretty bloody good too.” Pictures: Barleystore.com.au and Mark Stewart",
   "imagename1": "26-1",
   "imagename2": "26-2",
   "imagename3": "26-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 27,
   "peopleid": 27,
   "title": "Huon Valley Inspiration",
   "address": "Huon Valley, TAS",
   "desc": "Impressive as it is inspiring, this unique looking Huon Valley home is a showcase of how quality, comfort and style can sing in harmony with sustainable design features. The creation of a noted Tassie architect, the house is a showcase of energy efficiency. This includes its solar tube hot water system, solar passive window placements and insulated slab, walls and ceiling. It has an Envirocycle wastewater system and two large water tanks underneath the deck. Two atriums, set on each side of the living room, seem to bring the clean green Tassie countryside into the home. The property is also wired and reinforced, ready to add a solar battery. Pictures; Homelands Property\n",
   "imagename1": "27-1",
   "imagename2": "27-2",
   "imagename3": "27-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 28,
   "peopleid": 28,
   "title": "Waverley House",
   "address": "Waverley, NSW",
   "desc": "A magnificent example of contemporary sustainable design and living in an urban setting. The architects and owners had to deal with a number of challenges, including overshadowing to the north and the blistering western sun, and they more than rose to the challenge. Temperature-conscious, computerised louvres, like something out of a sci-fi flick, adjust automatically to cool the entire house in the warmer months. During Sydney's cooler climes, solar powered hydronic floor heating and radiant heat from the concrete floor ensure temperatures remain stable. All housed in a very good looking house.",
   "imagename1": "28-1",
   "imagename2": "28-2",
   "imagename3": "28-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 29,
   "peopleid": 29,
   "title": "The Village",
   "address": "Rivett, ACT",
   "desc": "A three home village built on a site where there was previously one home, this unique project challenges the narrative of the conventional home. The project in Rivett in the ACT was a collaboration between architects, scientists, clients and builders - the result is an intergenerational, multi-family complex. The aptly named “village” includes a yellow, red and orange house with varying floor areas of up to 140sqm. The different colours appear across many of the finishes, giving each house a unique identity. Light House Architecture and Science, along with 360 Building Solutions, described the home as “the ultimate sustainable approach to housing”, with a mix of earthy building materials and design concepts that maximise energy efficiency.",
   "imagename1": "29-1",
   "imagename2": "29-2",
   "imagename3": "29-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 30,
   "peopleid": 30,
   "title": "Castlecrag House",
   "address": "Castlecrag, NSW",
   "desc": "This unique home, built on a sandstone outcrop in an angophora forest, with a view of Sydney Harbour was designed by Neeson Murcutt Architects and won the Robin Boyd Award for Residential Architecture – Houses at the 2011 National Architecture Awards. Castlecrag House was built by the Maincorp Construction Group at Castlecrag on Sydney’s leafy upper north shore, and was designed to blend into its natural environment, with a pinwheel plan that takes in a room to the rock, a room to the bush, and a room to the view. Elements such as the original home’s chimney and surrounding fireplace joinery were carefully protected during construction, and the marrying of ‘new’ and old brickwork left exposed. The four-level home has shared family spaces at the entry level, a parents’ level above and children’s space below, with a pool level at the lower level.",
   "imagename1": "30-1",
   "imagename2": "30-2",
   "imagename3": "30-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 31,
   "peopleid": 31,
   "title": "Barossa Valley Glass House",
   "address": "Barossa Valley, SA",
   "desc": "Owners James and Helen Knight were thinking of more than just the picturesque panoramic views when they set out to build this Barossa Valley home. Designed by Max Pritchard and known as the Barossa Glasshouse, they wanted it to make the most of its surroundings. While walls of windows definitely showcase that, the house also works with that environment. It’s 57m long and 6m wide with each room facing north, which keeps it cool in summer and warm in winter. The roof eaves shield the home from the summer sun, while double-glazed windows prevent heat loss and concrete floors in the main living areas absorb, store and release heat. It also has a solar energy system that generates plenty of power for the house and water tanks. The house, which was finished in 2012 at a cost of $1.1m and featured on Grand Designs Australia, won an Australian Institute Of Architects award in 2013 for its sustainable design.",
   "imagename1": "31-1",
   "imagename2": "31-2",
   "imagename3": "31-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 32,
   "peopleid": 32,
   "title": "Verrierdale Tent House",
   "address": "Sunshine Coast, QLD",
   "desc": "For anyone with a love of the great outdoors and sleeping under the stars, this might just be your dream home. The ultimate in open-plan living, this stunning home 15 minutes outside Noosa features a retractable roof that pulls back to showcase the rainforest canopy and sky. The tent roof on this 500sq m home collects rainwater as the main source of the home’s potable water. A nurse and a doctor enlisted the help of architect Dan Sparks when they decided they wanted a home that was close to nature.The result is a $1.6m tent under the rainforest canopies of Verrierdale, just 15 minutes from Noosa. The finished product features a retractable roof which peels off and showcases the surrounding canopies of the rainforest. The pavilion has four bedrooms, a kitchen and living room in the centre. Another unique feature is the roof collects rainwater, making it the main source of water for the family to drink at home.",
   "imagename1": "32-1",
   "imagename2": "32-2",
   "imagename3": "32-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 33,
   "peopleid": 33,
   "title": "Reflections",
   "address": "Camp Mountain, QLD",
   "desc": "This home is green and clean. A boomerang-shaped roof, insulated with ARC panels, gives the impression of a floating form above the steel-framed home. The roof space harvests rainwater, stored in large underground tanks. The wide eaves keep the sun off the windows and enhance the floating effect of the roof. The building itself hugs the side of a hill at Camp Mountain in the Samford Valley. The upper floor is level with the grassy plateau while the lower level is anchored to the hillside by a rammed earth wall that acts as a wind shield to the southwest. The thermal mass of the rammed earth wall absorbs heat during the day and releases it at night to warm interiors while generous roof overhangs and high level glazing protect the home from the sun’s harshest rays.",
   "imagename1": "33-1",
   "imagename2": "33-2",
   "imagename3": "33-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 34,
   "peopleid": 34,
   "title": "Dandenong Ranges Passive House",
   "address": "Kallista, VIC",
   "desc": "One of Australia’s first “magic boxes” forms part of this eco-friendly house that blends into its forest surrounds, according to Maxa Design. The box integrates ventilation with heating, cooling and hot water. It also led to the home’s 7.4-star energy rating, which came about despite the trees blocking rooftop solar options and a lack of thermal mass due to the structure being raised off the ground. The design was inspired by a fallen, charred log on the property, and came from a need to maintain established grey gums on the bush site with a steep gradient. Impressive views are on offer from the rounded structure, which prevents leaves from building up to bring the property in line with regulations for bushfire-prone areas. Photos: Chris Neylon",
   "imagename1": "34-1",
   "imagename2": "34-2",
   "imagename3": "34-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 35,
   "peopleid": 35,
   "title": "Glass House",
   "address": "Bend of Islands, VIC",
   "desc": "The son of one of Victoria’s most celebrated architects used a “treasure trove” of recycled materials to create this low-impact build in Melbourne’s most sustainable suburb. Hamish Knox – whose father was master mud brick designer, Alistair Knox – salvaged materials including timber telegraph poles, commercial-grade glass from a Collins St tower and a striking Victorian staircase at the enchanting hideaway. Morrison Kleeman’s Gayle Blackwood said the patchwork home was designed to blend seamlessly into its natural surrounds. The pad gets bonus points for being within Victoria’s only Environmental Living zone, where the 300-odd residents are dedicated to preserving and enhancing the bush. This means abiding by regulations that prohibit keeping pets or livestock, introducing non-native plants, and inappropriate development, among other restrictions. Fencing is also largely banned so wildlife can roam uninhibited. The property sold for $825,000 in February.",
   "imagename1": "35-1",
   "imagename2": "35-2",
   "imagename3": "35-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 36,
   "peopleid": 36,
   "title": "Crayon House",
   "address": "Goodwood, SA",
   "desc": "Designed by architects Grieve Gillett Andersen, Crayon House, which was based on a child's drawing, has a playful colour palette both internally and externally, and represents that life is meant to be fun. However, sustainability plays a huge part in the energy-conscious zoned design, which is made up of two barn-like structures, one clad in timber, the other of metal. Joining the two forms is the central communal courtyard where decking, vegie patches as well as an arid garden design play a part while creating a delightful aspect from anywhere in the home. The design won the architect the John S Chappel Award for Residential Architecture - Houses (New) and the 2017 AIA (SA) Award for Sustainable Architecture at the state awards.",
   "imagename1": "36-1",
   "imagename2": "36-2",
   "imagename3": "36-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 37,
   "peopleid": 37,
   "title": "Red Zephyr Blue House",
   "address": "Perth, WA",
   "desc": "This intriguing home has collected a number of awards including the 2019 Perth GreenSmart Sustainable Home of the Year and is one of WA's best known sustainable homes. The highlight of which is probably the thermal chimney which allows the owners to adjust to the season and the time of day or night. Designed by Carrier and Postmus Architects with the build by Weststyle. Pictures: Supplied",
   "imagename1": "37-1",
   "imagename2": "37-2",
   "imagename3": "37-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 38,
   "peopleid": 38,
   "title": "The Shed",
   "address": "Naremburn, NSW",
   "desc": "This is the life. Who wouldn't want to spend a bit of me time here or even some quality time with your significant other, let alone call this eco-granny flat home. Designed by acclaimed architect Simon Anderson, who has several homes featured on our list, this contemporary home features a concrete thermal mass floor slab, highly insulated walls, increased cross ventilation, operable skylights and recycled materials.",
   "imagename1": "38-1",
   "imagename2": "38-2",
   "imagename3": "38-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 39,
   "peopleid": 39,
   "title": "Waramanga Rammed Earth",
   "address": "Waramanga, ACT",
   "desc": "This solar passive home's clever design is based around its north facing backyard and a spine of rammed earth, which provides the thermal mass to maintain a comfortable room temperature of 20-22 degrees year round. The low sitting sun throws light into the house in winter, keeping it warm, but in summer the home is shaded from light and heat. Water is heated via an efficient heat pump, heating is via hydronic heating in the insulated slab, and well placed windows provide cross ventilation and cooling. The home is all electric with a 9.6KW solar system, ensuring it is always energy positive and achieved a 8.8 star rating. Pictures: Kasey Funnell",
   "imagename1": "39-1",
   "imagename2": "39-2",
   "imagename3": "39-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 40,
   "peopleid": 40,
   "title": "Eco Statement",
   "address": "Townsville, QLD",
   "desc": "This statement residence in Townsville was built by Ecobuild Qld and sold for $775,000 in 2017. At the time it was the first 9 star energy rated two storey house in North Queensland. Incorporating a north-east orientation, the design allowed for cross-ventilation, and used lightweight construction materials, insulation and glazing to keep the residence cool. It also features large eaves and awnings, solar power, water saving technology, recycled materials, LED lighting, ecofriendly paints, finishes and floor coverings, and the installation of an innovative ‘priority switch’ that allows the occupants to turn off all standby power at the flick of a switch. It has an open plan design that flows out onto the large patio with lake views, an alfresco patio with bi-fold doors, high ceilings, and five bedrooms, all on a 599sqm block.",
   "imagename1": "40-1",
   "imagename2": "40-2",
   "imagename3": "40-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 41,
   "peopleid": 41,
   "title": "4 Explorers Dr, South Mission Beach",
   "address": "Cairns, QLD",
   "desc": "Waking up to this view everyday would be a dream come true. Perched on the best hill of South Mission Beach, this three-level property stands out from the rest in this tropical paradise with its unique, glass turrets. Relaxed, open-plan living areas extend to an outdoor terrace that spans the length of the house — making the most of the endless ocean and island views. But the infinity pool and barbecue pavilion surrounded by lush are where you would want to spend most of your time, surrounded by nothing but rainforest and the ocean. The house has been built to the highest standard and occupies a massive 5083 sqm block, offering complete privacy and making it the ultimate tropical hideaway. The home also gets points for its eco credentials, given it has a 7 Star Energy Efficiency Rating.",
   "imagename1": "41-1",
   "imagename2": "41-2",
   "imagename3": "41-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 42,
   "peopleid": 42,
   "title": "Bundeena House",
   "address": "Bundeena, NSW",
   "desc": "A treehouse among the canopies, this home in Bundeena was originally thought of as an investment but quickly became a permanent home as the owner-builder fell in love with area. Elevated on steel columns to minimise the impact on rocky outcrops and plants, the property has two floating roofs that allow the surrounding nature and light to enter. The design, by RAAarchitects, allows for a 6.8KW solar system with the materials used like the steel framing, plywood linings and timber floors all still providing a holiday home feel. Picture: Michael Nicholson",
   "imagename1": "42-1",
   "imagename2": "42-2",
   "imagename3": "42-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 43,
   "peopleid": 43,
   "title": "Thylogale",
   "address": "Kettering, TAS",
   "desc": "When it comes to off-grid homes in Hobart, Peter and Robyn Tuft's solar passive property Thylogale is a leader, an inspiration and a constant fixture at Sustainable House Day events. And it's easy to see what people love about it. In its remote hilltop location, the house is fully energy and water self sufficient. It produces more energy than they need with the excess used to charge an electric car. Ceiling-high stone fireplace provide thermal mass to trap more warmth in the home. A wetback wood heater warms the home's pavilions, rainwater is collected in tanks, it has composting toilets and grey water is filtered through reed beds before being used as irrigation around the 80ha property. PICTURES MATT THOMPSON AND SUPPLIED",
   "imagename1": "43-1",
   "imagename2": "43-2",
   "imagename3": "43-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 44,
   "peopleid": 44,
   "title": "Core 9 Project",
   "address": "Cape Paterson, VIC",
   "desc": "Awarded the top accolade in the 2019 HIA Australian GreenSmart Awards, the Core 9 Project display home by Beaumont Building Design and TS Constructions boasts a 9.1-star energy rating that ensures has no electricity costs for a family of four. This is in part achieved by a 6kW solar PV system and battery energy storage. “Like a series of checkerboards, the panels slope down over the windows of the kitchen and lounge room, rather than adhering to the customary rooftop location,” the HIA website states. Passive-solar design is also at play, via windows strategically placed for cross ventilation, a 900mm eave and a timber blade shading system. A 10,000 litre rainwater tank and locally sourced materials are other sustainable features of the affordable home, which the HIA says proves “sustainability and contemporary design can go hand in hand”.",
   "imagename1": "44-1",
   "imagename2": "44-2",
   "imagename3": "44-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 45,
   "peopleid": 45,
   "title": "Passive Butterfly",
   "address": "Armadale, VIC",
   "desc": "Crowned the Best of the Best at the 2018 Sustainability Awards, this EME Design project turned an “inefficiently performing” heritage home into “an archetype for sustainable, healthy and happy living”, jurors said. It features an asymmetric butterfly-shaped roof that is not only aesthetically beautiful, but also draws sun into “a light-starved extension by optimising solar access both internally and externally”. The multi-award-winning Melbourne house also maintains a compact footprint, generates more energy than it requires and reuses collected rainwater. According to EME Design, its temperature, humidity, indoor air quality and electricity consumption are monitored constantly, returning “exemplary results throughout the year”, making it an educational resource for the Australian Passive House Association and Alternative Technology Association. The architecture firm also works to educate the public, universities and housing industry on sustainable practices. Pictures: Amorfo",
   "imagename1": "45-1",
   "imagename2": "45-2",
   "imagename3": "45-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 46,
   "peopleid": 46,
   "title": "Quirky Nature",
   "address": "Brompton, SA",
   "desc": "Architecturally redesigned using raw and recycled materials, it’s fair to say this three-bedroom Brompton home is unlike any other. Wood, concrete, brick and glass are featured extensively throughout to make it feel like part of the environment. The project was a labour of love for former owner Damien Chwalisz, who is the founder and studio director of Damien Chwalisz: Architects. Skylights and a twin polycarbonate skinned roof on the extension, which is designed to feel like a conservatory, maximise natural light and airflow through the house. Mr Chwalisz also reused a lot of materials, both from the house itself and elsewhere, including a Goodwood bowling alley and a plant room at Adelaide Airport. To top it off, the house is environmentally friendly, with grey water fed back into the garden and a 5KW solar system for electricity.",
   "imagename1": "46-1",
   "imagename2": "46-2",
   "imagename3": "46-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 47,
   "peopleid": 47,
   "title": "Whiptale Strawbale House'",
   "address": "Scenic Rim, QLD",
   "desc": "It’s hard to go past Whiptale Strawbale House when you’re talking about a self-sufficient sustainable housing. Designed by architect Emma Scragg, it took five years and a labour of love from almost 300 hundred volunteers, under the supervision of Rob Peagram Builders and future residents Justin and Lizz, to create the quintessential 'recycled' and sustainable home. It forms part of the Wild Mountains Environmental Education Centre and features straw bale external walls. It has recycled hardwood framing, linings and second hand timber doors. The raking ceiling is heavily insulated and lined with sustainable plywood, while the 550mm thick clay-rendered straw walls and double-glazed windows also help keep a consistent temperature year round. There’s a composting toilet and greywater gathered from the solar-heated shower, kitchen and washing machine is treated to cut down on rainwater consumption. It even has a BAL-19 (Bushfire Attack Level) to withstand a moderate threat, such as withstanding burning embers and an increasing heat flux. To top it off, a permaculture gardens improve food self-sufficiency. Ticks the boxes!",
   "imagename1": "47-1",
   "imagename2": "47-2",
   "imagename3": "47-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 48,
   "peopleid": 48,
   "title": "Apple Crate Shack",
   "address": "Flowerpot, TAS",
   "desc": "Modest and humble, that was a goal for this creative home at Flowerpot. With a floorsize of just 61sq m and a budget of equally tiny size, Hobart architect Andrew Kerr relied on creativity to design and build his Apple Crate Shack. Also known as the 60k House, Kerr's single-bedroom slice of country paradise was built with recycled bricks from old footings and chimneys. The home's timber cladding came from trees that had to be felled at the site to comply with bushfire regulations. Then there is the Huon pine duck boards in the indoor-outdoor shower, a fantastic highlight, and a challenge too... if one is brave enough for a chilly winter under-the-stars shower. PICS BY ANDREW KERR\n",
   "imagename1": "48-1",
   "imagename2": "48-2",
   "imagename3": "48-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 49,
   "peopleid": 49,
   "title": "Michael Mobbs' sustainable House",
   "address": "Darlington, NSW",
   "desc": "Since 1996, Michael Mobbs has been disconnected from the water and sewerage mains, resulting in bills of less than $300 a year. In 2015 he moved away from the poles and wires of the main electricity grid, with solar panels and batteries now powering the house. A pioneer in the sustainable homes trend, the property has been viewed by over 30,000 people from around the world and looks like any other three-bedroom inner city terrace. Rain water tanks, recycled water usage, a waste system and a couple of chickens have contributed to the performance of this sustainability forerunner.",
   "imagename1": "49-1",
   "imagename2": "49-2",
   "imagename3": "49-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 50,
   "peopleid": 50,
   "title": "Eco beauty",
   "address": "Flinders Park, SA",
   "desc": "It’s a perfect example of how style and sustainability can be expertly blended in a home, allowing its owners to enjoy the best of both worlds. The four-bedroom Flinders Park residence, which was built by Frank Giorgio of United Constructions, showcases sustainable architecture from Peter Morris of Swanbury Penglase. The skillion roof over the main living areas, which maximise the winter sun and cross ventilation, extends over the bedrooms,providing an eye-catching design feature from the street. Natural materials, including sandstone, zinc and timber, have been used to create the home’s appealing exterior, while a western red cedar creates a screen for the courtyard off the main bedroom. Furthermore, the designer garden features water-tolerant plants and a covered vergola, which makes the space usable year-round. It also allows sun to enter the dark tiled living area floors for thermal storage during winter.",
   "imagename1": "50-1",
   "imagename2": "50-2",
   "imagename3": "50-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 51,
   "peopleid": 51,
   "title": "Currumbin Valley Eco Village",
   "address": "Gold Coast, QLD",
   "desc": "Made up of five interconnected yurts, this house is situated in Currumbin Valley's award-winning Eco Village. Traditionally designed, they were the first green yurts to be built in Australia and are cleverly connected by outdoor walkways and verandah. While each yurt is unique, every pavilion has been built using sustainable and recycled timber, including blackbutt timber for the parquetry flooring and hand-built cabinetry. Ventilation is achieved through the complex cupola ceiling design. Sat on a 1401sq m block, every inch of the land is fertile, and can be used for growing fruit and vegetables. It comes with 58,000l rainwater tanks and a 2.5kW solar system and solar hot water. The Eco Village is an internationally renowned sustainable community, which has been awarded 33 environmental awards, including the The World’s Best Environmental Development (FIABCI Prix D’Excellence Award 2008). It is home to 450 residents and 120 properties, which have to be built to strict sustainability criteria.",
   "imagename1": "51-1",
   "imagename2": "51-2",
   "imagename3": "51-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 52,
   "peopleid": 52,
   "title": "The Tree House",
   "address": "Coburg, VIC",
   "desc": "A few materials as possible went to waste when Adapt Architecture recreated a post-war weatherboard in Melbourne’s inner north as The Tree House. The sustainability-focused architecture firm even reused dirt that was dug out to accommodate a lower level, building it into the walls to improve energy efficiency, director Nathan Cagliarini said. “The new walls we created with the extension are far better insulated and sealed than a lot of houses constructed today,” he said. “And rather than more timber being milled, we repurposed what was there, (so the build required) less energy in terms of manufacture and supply.” A 1kW solar power system, 9000 litre rainwater tank, double-glazed windows and upcycled timber furniture and cabinets are other sustainable features of the 6.9-star energy rated home, which is also aesthetically striking. It was a finalist in the 2019 Sustainability Awards.",
   "imagename1": "52-1",
   "imagename2": "52-2",
   "imagename3": "52-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 53,
   "peopleid": 53,
   "title": "Photosynthesis house",
   "address": "Manly, NSW",
   "desc": "This stunning contemporary abode lives up to its name - the abundance of natural light it enjoys defines the home. As with many of architect Matt Elkan's designs simplicity is key. The home's orientation and skylights allow it access to as much light as possible - all rooms are north facing, while other sustainable features, such as a green roof watered by runoff are key. External venetian blinds and glass louvres mean the owners can moderate sunlight and airflow as they wish in this house that was the result of a remarkable renovation of an old fibro beachside cottage.",
   "imagename1": "53-1",
   "imagename2": "53-2",
   "imagename3": "53-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 54,
   "peopleid": 54,
   "title": "Tin Shed House",
   "address": "Gymea, NSW",
   "desc": "A key focus here was to create a home that would be a pleasure to live in using sustainable design principles. “When you talk about environmentally responsible design, size is quite critical,” said Chris Chris Freeburn from Ironbark Architecture. “With all our projects we advocate for less but better. We’re always asking the question ‘how little do we need?’ ” Maintaining comfortable temperatures without the need for heating and cooling was also a key consideration. “The three questions we always ask are: Where is the sun? Where are the views? Where are the breezes?” Chris said. “The answers to those questions drive the whole project.” The result: a three- bedroom 150 sqm home over two levels after a 12 month build. Using 3D modelling, Chris identified how best to capture the sun in winter and reduce its impact in summer, as well as the prevailing breezes. Credit: Architect Ironbark Architecture, Builder Build by Design, Pics by The Guthrie Project",
   "imagename1": "54-1",
   "imagename2": "54-2",
   "imagename3": "54-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 55,
   "peopleid": 55,
   "title": "No Bills House",
   "address": "Donvale, VIC",
   "desc": "This five-bedroom mansion in Melbourne’s east was estimated to cost up to $3000 a quarter to run. But thanks to a $50,000 economical energy system, the previous owners’ bills were in credit. The system includes two Tesla batteries, 20kw of solar and a network that feeds the surplus power back into the grid. So much for the bigger the house, the bigger the bills. While their house is making them money, the owners can enjoy luxurious features including a Cheminees Philippe fireplace, soaring ceilings, a statement water feature and treetop views. And for horse enthusiasts, there are seven paddocks and three stables. The property sold within just three weeks in 2019, for $3.98m.",
   "imagename1": "55-1",
   "imagename2": "55-2",
   "imagename3": "55-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 56,
   "peopleid": 56,
   "title": "Canberra Beach House",
   "address": "Wright, ACT",
   "desc": "Having this cutting edge home in a new suburb is a good indication of where demand for sustainable dwellings is at. Owners the Edwards family wanted a home that felt like a beach holiday home . The 'Light House' is a play on that but also on how the home manages to overcome poor orientation with good design to make the best use of natural light. This award-winning 'light-footed' 4-person home uses the same electricity as an average 1-person Canberra home. Pictures: Light House Architecture and Science",
   "imagename1": "56-1",
   "imagename2": "56-2",
   "imagename3": "56-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 57,
   "peopleid": 57,
   "title": "Tamar House",
   "address": "Tamar Valley, TAS",
   "desc": "This seachange home on the banks of the River Tamar in Tasmania featured on this year's series of Grand Designs Australia. \"One of the stand-out features for me is that fireplace. It was a really big investment for such a little house and it took up a lot of the budget – it’s half fireplace, half house I reckon,\" GDA host Peter Maddison said. \"It was such a massive undertaking on a small timber house but [co-owner] Matt was determined to build it, because he and [fellow co-owner] Eloise consider the fireplace to be the heart of the house. This is a fantastic build, and it's got such heart to it, because it really was a labour of love from Matt. He and Eloise are a great couple and Matt really put himself out there - he was building at nights and weekends while working full-time, with a growing family and a dog and living in a shed! It’s just incredible.\" Pictures: Grand Designs Australia",
   "imagename1": "57-1",
   "imagename2": "57-2",
   "imagename3": "57-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 58,
   "peopleid": 58,
   "title": "Off-the-grid earthship",
   "address": "Inman Valley, SA",
   "desc": "Still under construction, the Inman Valley earthship is a lesson in off-the-grid living. Designed by Earthship Eco Homes' Dr Martin Freney and built with mostly volunteer manual labour, it is being constructed from recycled tyres, straw bales, glass bottles and rammed earth. Owners Evie and Tristan wanted a self-sufficient, passive solar dwelling that was off-grid and designed to ensure there would be no power, water or sewerage bills. The long, narrow earthship home, built into the hillside from materials with high insulation values, will feature a kitchen, living and dining area at the west end, as well as two bedrooms, a rumpus, separate study, a bathroom and laundry when complete later this year. Their home will be fully off-grid with water caught from the roof, collected in rainwater tanks and filtered to the bathroom and toilet, with a septic tank sewage system, plant wicking beds and have solar panels and battery storage for electricity.",
   "imagename1": "58-1",
   "imagename2": "58-2",
   "imagename3": "58-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 59,
   "peopleid": 59,
   "title": "Casa Bianca",
   "address": "Bundaberg, QLD",
   "desc": "Keep it light, capture breezes and wind back on western windows. When Kleidon Masterbuilt Homes designed this Innes Park North mansion, these three key points were front and centre of all their building choices. So with the garage on the western wall and ocean breezes flowing through the home which is a short 250m from the beach, they set to work.\nThe Italian-inspired mansion which was finished in time for Christmas 2019, has since picked up three Master Builders regional awards for its design and sustainable building elements, and has demonstrated the depth of site-specific knowledge this local builder has acquired over almost 40 years working in the Bundaberg region. Tinted glass windows, light-coloured paint throughout, insulation in the wall between the western garage and the main house, and shutters that divert ocean gales while allowing the house to cool naturally, have all contributed to its award-winning status and we think it provides practical tips for all homeowners working toward a cooler summer in 2021.\nIts sustainable features include solar block 2 tinted glass, a 6.4-star Energy Efficiency rating, efficient lighting and fixtures, roof and wall\ninsulation, natural lighting, solar roof panels, high ceilings and an automated garden irrigation\nsystem.",
   "imagename1": "59-1",
   "imagename2": "59-2",
   "imagename3": "59-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 60,
   "peopleid": 60,
   "title": "Noonamah Family Retreat",
   "address": "Noonamah, NT",
   "desc": "The passive design principles used in this home may be of greatest benefit to those in the northern part of Australia, including louvre windows, shaded windows and solar exposed walls with vegetation. According to the builders M+J Builders and also the owners of this incredible home: 'This carefully constructed home uses passive design principles and select building materials that suit the Northern Territory’s climate, keeping the home comfortable, cool and energy efficient year-round'. Pictures: M+J Builders",
   "imagename1": "60-1",
   "imagename2": "60-2",
   "imagename3": "60-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 61,
   "peopleid": 61,
   "title": "Limestone House",
   "address": "Toorak, VIC",
   "desc": "The environmental agenda of this eye-catching John Wardle Architects-designed home in Melbourne’s priciest suburb follows two certifications: Passivhaus and Living Building Challenge. The firm’s website states the former has been achieved by “creating a very high-performing and uninterrupted building envelope” via excellent insulation and triple-glazed windows, with the air tightness and leakage tested at three stages during the thoughtful construction process. To address the Living Building Challenge, the 2015-19 project was designed to be self-sufficient in managing its water and wastewater, and have a “photovoltaic cell system with battery storage” to meet the house’s total energy needs. It was built with natural materials from across Australia, most notably Mt Gambier limestone cladding from South Australia, and has been named as a finalist in two Houses Awards 2021 categories: sustainability and best new house over 200sq m. Pictures: Dianna Snape",
   "imagename1": "61-1",
   "imagename2": "61-2",
   "imagename3": "61-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 62,
   "peopleid": 62,
   "title": "Olinda House",
   "address": "Olinda, VIC",
   "desc": "\nWhen vets Matt and Leanne engaged Bent Architecture to create them an energy-efficient home on a 1.4ha block within walking distance of Olinda and Sassafras, in the Dandenong Ranges, they were adamant the project should not disturb the site. “A really critical part of their brief was to minimise site disturbance and avoid the removal of the existing trees,” Bent’s Paul Porjazoski said. “In order to do that, we had to use the footprint of the original house.” The resulting long, narrow house stretching from east and west captures northern light and cooling summer breezes via strategically placed windows. A polished concrete floor also soaks up winter sun, while 60 solar panels adorn the roof, leaving Matt and Leanne with an estimated annual power bill of just a couple of hundred dollars. The split-level design allows for higher ceilings, the minimalisation of bushfire-hazardous leaf build up, and for the home to hug the natural slope of the land. The project was a finalist in the 2020 Sustainability Awards and Australian Timber Design Awards. Pictures: Tatjana Plitt",
   "imagename1": "62-1",
   "imagename2": "62-2",
   "imagename3": "62-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 63,
   "peopleid": 63,
   "title": "North Narrabeen Treehouse",
   "address": "North Narrabeen, NSW",
   "desc": "This award-winning family home with granny flat is proof you don’t need a massive budget to bring a sustainable design to life. Located in North Narrabeen, on Sydney’s northern beaches, the very steep, heavily treed block presented plenty of challenges, although offered the bonus of ocean views and a treehouse feel. The budget for the build was tight, however the best insulation details and thermally broken, double-glazed windows were installed to help maintain the house’s passive solar approach. Hydronic heating was also installed to boost the comfort levels in winter. Under the garage, four 18,000L rainwater tanks harvest the roof water and this is used for the whole house. A 2.5kW PV system provides for the house’s electricity needs, and the solar hot water system with gas boost provides the domestic hot water and hot water for the hydronic heating and even the suspended pool. The Envirotecture-designed home won the Sustainable Residential Building Award at the 2013 Building Design Australia design awards.",
   "imagename1": "63-1",
   "imagename2": "63-2",
   "imagename3": "63-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 64,
   "peopleid": 64,
   "title": "Suntrap",
   "address": "Lewisham, NSW",
   "desc": "Suntrap House was completed in 2017 and is a fantastic example of inner city sustainability. The garden and utilising natural light was the most important part of the home, so it is centred around a northern courtyard. Ecofriendly concrete walls, hydronic heated flooring and repurposed materials all add to the home's unique design and build. The Australian native garden promotes birdlife and other local fauna. Photography: Nick Bowers/Anderson Architecture",
   "imagename1": "64-1",
   "imagename2": "64-2",
   "imagename3": "64-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 65,
   "peopleid": 65,
   "title": "Greenhill Dream",
   "address": "Kingston, TAS",
   "desc": "Here is a home that strikes a perfect balance. On one side, it is a sleek modern family home that feels luxurious from front to back. And on the other side, it was cleverly designed and built with HIA GreenSmart principles informing its creation. This leads to the orientation of the living areas and bedrooms facing north to take advantage of the winter sun. The builder positioned solid masonry walls in the living areas to act as a thermal mass and store daytime warmth to releases after sundown. This modern marvel maximises energy efficiency with its full insulation, double-glazed windows and double honeycomb blinds. Pictures: Blue Edge Property",
   "imagename1": "65-1",
   "imagename2": "65-2",
   "imagename3": "65-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 66,
   "peopleid": 66,
   "title": "Myrtle House",
   "address": "Myrtle Bank, SA",
   "desc": "We first showed you this eco wonder in 2019, when it was opened to the public for Sustainable House Day, and we’ve not managed to lose interest in it since then. The brief was simple – replace an existing 1930s house with a contemporary low-carbon footprint home big enough for a family of six. The result – nothing short of stunning. The 8.1 star, five-bedroom home designed by TS4 Living and built by Aria Homes features $55,000 worth of sustainable features including a 6.4kw solar system, efficient lighting and appliances, 22,500L of above-ground rainwater storage and is surrounded by a waterwise garden. Oh, and did we mention it’s gorgeous?",
   "imagename1": "66-1",
   "imagename2": "66-2",
   "imagename3": "66-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 67,
   "peopleid": 67,
   "title": "Mountain of Joy",
   "address": "Brisbane, QLD",
   "desc": "A finalist in the HIA House of the Year awards, this cleverly designed home takes inspiration from Cape-Cod style architecture and combines contemporary livability with sustainability. With glorious views of Moreton Bay, the striking timber and stone facade stands out from the rest in this run-of-the-mill bayside Wynnum street. It has been designed to utilise the bay breezes. Raked ceilings help create cross-flow ventilation to heavily reduce the need to rely on the air conditioner on the hottest of days, \"unless it is stiflingly hot and there is no breeze\", said Build Prestige Homes director Leo Bandieria. Double insulation in the roof, includes a lining underneath the roofing iron and a second layer on top of the plasterboard ceiling sheets, and insulation within the external walls to further reduce the need to draw on electricity. All electrical appliances feed off solar power while lights and elements are LED to minimise the draw on voltage.Smart home technology allows for lighting to be controlled by an app that can create a \"mockupancy\", an occupancy simulation, of your lighting habits that provide the illusion that someone is home when the house is unattended. The five-bedroom, two-bathroom residence in Mountjoy Terrace is on the market. ",
   "imagename1": "67-1",
   "imagename2": "67-2",
   "imagename3": "67-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 68,
   "peopleid": 68,
   "title": "Bowen Dreaming",
   "address": "Bowen, QLD",
   "desc": "The Baxter Avenue home is the culmination of the great Australian dream. This beauty was the winner of the Master Builders Excellence in Sustainable Living, 2020 Mackay & Whitsunday Housing & Construction Awards. The open plan, coastal family property features four bedrooms, two bathrooms, large kitchen and lounge, study nooks, a kids retreat, laundry, decking, landscaped gardens and full ocean views. Solar panelling and rainwater tanks have been installed for sustainable living, while the design allows for an unobstructed airflow with minimal reliance on refrigerated air conditioning systems. The solar design minimises direct sunlight and solar heat entry through windows and glazing, especially in summer months, while rainwater captured from the roof space is stored in a tank supply.",
   "imagename1": "68-1",
   "imagename2": "68-2",
   "imagename3": "68-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 69,
   "peopleid": 69,
   "title": "Best of both worlds",
   "address": "Harrogate, SA",
   "desc": "Going off-grid doesn’t mean leaving luxury in the past. Here at Flintberry Farm, you can get the best of both worlds in a package that’s good for both the environment and the soul. The home, designed by Architecture in the Wild, is energy efficient, has a worm farm septic system, is constructed from a range of recycled materials, has a 12.5kw solar system with 25kw battery storage, double-glazed windows and offers 220sqm of glam living space. Plus, for gardeners, it’s surrounded by more than 70 fruit, nut and berry plants, as well as a large vegetable garden. Oh, and it’s also got one of the most impressive pool views you’re likely to come across ...",
   "imagename1": "69-1",
   "imagename2": "69-2",
   "imagename3": "69-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 70,
   "peopleid": 70,
   "title": "Elemental House",
   "address": "High Camp, VIC",
   "desc": "This modest off-the-grid home 90 minutes north of Melbourne has a small 10x10m footprint, produces and stores its own power, collects rainwater, treats its own waste water on site and is fire resistant. It “shuns the excesses of modern life”, but doesn’t sacrifice on comfort. The semi-retired owners engaged architect Ben Callery and Keenan Built’s James Glover to create a home that did more with less — and took advantage of panoramic views on offer from the property’s position high on a hill. The structure is exposed to harsh Australian elements, including cyclonic winds and bushfires, but it embraces its rough and rugged surrounds. It featured in Renew’s 2020 Sustainable House Day. Pictures: Jack Lovel",
   "imagename1": "70-1",
   "imagename2": "70-2",
   "imagename3": "70-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 71,
   "peopleid": 71,
   "title": "Vivarium",
   "address": "Thornbury, VIC",
   "desc": "This cottage in Melbourne’s inner north with an environmentally friendly extension is about as one with nature as a house can be. According to designers Architecture architecture, the abode will “in time … be consumed by its gardens”. “Already the buzz of pollination fills the air: bees, blowies and butterflies,” the firm’s website states. “This is a house that sympathises with its environment, locally and globally.” Materials for the extension were locally sourced where possible and chosen for their low-environmental impact. The project is a finalist in the 2021 Houses Awards sustainability and best alteration and addition under 200sq m fields. Pictures: Tom Ross",
   "imagename1": "71-1",
   "imagename2": "71-2",
   "imagename3": "71-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 72,
   "peopleid": 72,
   "title": "A Star is Born",
   "address": "Woodforde, SA",
   "desc": "A four-star review is great. A five-star review is even better. On that basis, this 10-star home in Adelaide’s foothills is simply a massive overachiever. Achieving a 10-star NatHERS rating, every single aspect of the everyday running of the home has been looked at to ensure this tech-packed home is as efficient as possible. The home uses efficient appliances, is draught proof, employs cross ventilation and boasts a passive solar design. It’s also got good water storage, and 90 per cent of the materials taken from the site were recycled. Basically, everything an efficient home should do, this place does. And it manages to be beautiful in the process.",
   "imagename1": "72-1",
   "imagename2": "72-2",
   "imagename3": "72-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 73,
   "peopleid": 73,
   "title": "Verve House",
   "address": "Toowoomba, QLD",
   "desc": "Toowoomba builders Janke Constructions wowed judges with their Verve Home project which took out House of the Year at the Masterbuilders Queensland Downs and Western Housing and Construction Awards last year. The escarpment residence was also awarded best Individual Home $1.26 million-$2 million and Best Use of Sloping Sites. Large in size and modern in design, it blends into the natural landscape, according to the Masterbuilders Queensland judges. It includes energy efficient installations and innovative technical products, with the windows fitted with Low E glazing to enhance the energy credentials of the home. It’s also fitted with a 16kW Enphase solar power system equipped with a battery storage system, while thermal insulation has been installed to all suspended floors.",
   "imagename1": "73-1",
   "imagename2": "73-2",
   "imagename3": "73-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 74,
   "peopleid": 74,
   "title": "Sky Ridge",
   "address": "Kangaroo Valley NSW",
   "desc": "Popular Channel 7 Morning Show co-host Larry Emdur and wife Sylvie snapped up this weekender in the rolling hills of Kangaroo Valley last year for $2.15m, with a view to turning it into tourism accommodation. The luxury offering was designed by architect ­Alexander Michael in 2018. The off-grid, solar-powered, eco-friendly home was constructed from steel, glass and polished concrete floors to give it an industrial feel. The property has solar panels with a battery bank and rainwater harvesting. It also features two towering floor-to-ceiling fireplaces in the open-plan living area. The four bedroom pods are accessed on the second level of the property, each with their own ensuite.",
   "imagename1": "74-1",
   "imagename2": "74-2",
   "imagename3": "74-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 75,
   "peopleid": 75,
   "title": "Box House",
   "address": "Bateman's Bay, NSW",
   "desc": "Box House celebrates the pleasure of camping with a simple cube structure. Designed by Nicholas Murcutt Architect, the house is essentially a \"hard tent\" that complements the pre-existing campfire and outdoor bathtub that the clients had established as part of their campsite on the lot. It has been built sustainably with recycled hardwood, a water tank and square wooden windows that allow a cross breeze and natural light to flow in.",
   "imagename1": "75-1",
   "imagename2": "75-2",
   "imagename3": "75-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 76,
   "peopleid": 76,
   "title": "Healthy alternative",
   "address": "Woodville, SA",
   "desc": "It’s not just the environment this character home is helping – it’s also protecting its occupants’ health. The classic bungalow in Woodville was renovated by its former owner Liz Cook, who is the founder of organic perfume label One Seed, to ensure it was eco-friendly and low toxic. Volatile Organic Compounds (VOC) free paint, naturally oiled pine floors and ethically sourced materials can be found throughout. Ms Cook is so passionate about all things natural that she never used any chemicals in the house either. The property ended up proving so popular among househunters that it sold for $738,000 at its well-attended auction in November last year. Its selling agent said at the time eco-friendly and low toxic homes like this one didn’t hit the market often in Adelaide.",
   "imagename1": "76-1",
   "imagename2": "76-2",
   "imagename3": "76-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 77,
   "peopleid": 77,
   "title": "Somerton Park Project",
   "address": "Somerton Park, SA",
   "desc": "Mirage Homes are leaders when it comes to building beautiful bespoke eco homes, and have fine-tuned the balance between sustainable design and dream-home style. As well as being conscious of the build process and working with recycling specialists to reduce waste, they consider the long-term environmental costs and design homes to minimise ongoing energy costs and efficiencies. Each home, including this 8.1-star Somerton Park project is a one-off. This modest three-bedroom home strikes an ideal balance between design, sustainability and lifestyle creating a high-performance, environmentally conscious solution uniquely tailored to the site. Capturing the sense of individuality was a key driver in creating a restrained yet elegant home perfectly tailored the occupants' needs which includes \nopen plan living spaces with extended garage and caravan storage. The builder has won Greensmart sustainable awards for past projects.",
   "imagename1": "77-1",
   "imagename2": "77-2",
   "imagename3": "77-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 78,
   "peopleid": 78,
   "title": "Mornington Peninsula Passivhaus",
   "address": "Mt Eliza, VIC",
   "desc": "This was Victoria’s first residence designed to the German Passivhaus criteria, making it “about two-and-a-half times more energy efficient than current best practice”, according to building company Davies Henderson. And it has star power to boot, having been snapped up by pop sensation Tones and I for more than $5m last year. The Passivhaus approach to design requires high insulation levels and “addresses air leakage” by ensuring the build is airtight. Solar systems also generate electricity, hot water supply and pool heating to ensure occupants enjoy almost zero energy consumption. The five-bedroom Mt Eliza abode features a wellbeing centre with a steam room, a sauna, a pilates studio and two treatment rooms. The 2738sq m block is covered in edible gardens and has a heated, self-cleaning pool and an outdoor shower.",
   "imagename1": "78-1",
   "imagename2": "78-2",
   "imagename3": "78-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 79,
   "peopleid": 79,
   "title": "Imprint House",
   "address": "Alexandria, NSW",
   "desc": "Anderson Architecture have transformed a typical Alexandria terrace into an award-winning eco home. Built for a young environmentally conscious family, the property has a polished concrete slab that collects and stores both warmth from the sun as well as heat generated through the hydronic heating pipes which run through it.This concrete slab was constructed from Green Star 3 concrete with fly ash cement replacement, which cuts CO2 emissions by 1 ton per cubic metre of concrete used. There are also double glazed timber windows, rainwater and insulation.",
   "imagename1": "79-1",
   "imagename2": "79-2",
   "imagename3": "79-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 80,
   "peopleid": 80,
   "title": "Sustainable, Recycled Canberra House",
   "address": "Canberra, ACT",
   "desc": "This recycled home in suburban Canberra was designed to fit in with the surrounding neighbours but it is no ordinary home on the inside. The double-height entry was designed to act as a thermal chimney, venting warm air into the living areas. The layout is a series of light-filled spaces around a spine of rammed earth that regulates the humidity and temperature. The home stays a constant 20-22 degrees even in the chilly Canberra winters. A project by 360 Building Solutions, the bedrooms face north in a way that allows the sun to pour in during winter, while a pergola of recycled timber blocks the summer sun. A heat pump supplies hot water and minimises energy use. There is also a battery system.",
   "imagename1": "80-1",
   "imagename2": "80-2",
   "imagename3": "80-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 81,
   "peopleid": 81,
   "title": "The Cove",
   "address": "Sanctuary Cove, QLD",
   "desc": "The Cove house at Sanctuary Cove won the national home building industry’s top award in 2020. Designed by Justin Humphrey Architect and built by BJ Millar Constructions, it also took the gong at the HIA-CSR Australian Housing Awards for best custom-built home. The HIA described The Cove House as ‘a sophisticated nod to brutalist architecture and tropical modernism, masterfully crafted with an extraordinary level of customised detail’.It was built using natural materials, with a strong indoor/outdoor living focus incorporating central gardens within its interior design. The home has large roof overhangs, while 54 solar panels, a submerged rainwater tank and three Tesla energy storage batteries allow it to exist almost off the grid. It is currently for sale for $7.85 million and marketed by Trish Edwards of Ray White.",
   "imagename1": "81-1",
   "imagename2": "81-2",
   "imagename3": "81-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 82,
   "peopleid": 82,
   "title": "Sapphire Passive House",
   "address": "Faulconbridge, NSW",
   "desc": "Come winter or summer, the internal temperature inside this Blue Mountains retreat stays 20-25 degrees. That’s thanks to high performance glazing and insulation and an airtight building. The materials together with building physics, remove the need for artificial heating or cooling. A ventilation system brings filtered air into the house, preventing Carbon Dioxide build up inside. Designed by Sapphire and Blue Eco Concepts, the carbon-zero house in Faulconbridge is the first Certified Passive House in the Blue Mountains. It is also the first Certified Passive House in Australia to be built to the highest bushfire risk rating.",
   "imagename1": "82-1",
   "imagename2": "82-2",
   "imagename3": "82-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 83,
   "peopleid": 83,
   "title": "Ferry Rd House",
   "address": "Glebe, NSW",
   "desc": "Warm winters and cool summers, that's what the reality is at this Ferry Rd house in Glebe following a recent extensive renovation. The owners claim that the insulation means temperatures never rise above 26 degrees inside, which is means there is no air conditioning. The Glebe house has a light-filled central courtyard with green wall, a 3.2kW solar system, an insulated concrete filled wall system and a low floor to glass ratio of 27 per cent. The concrete used by Anderson Architecture for the slab and boundary walls has reduced C02 emissions by 17 per cent and embodied energy by 14 per cent.",
   "imagename1": "83-1",
   "imagename2": "83-2",
   "imagename3": "83-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 84,
   "peopleid": 84,
   "title": "Folk Of All Trades Strawbale Home",
   "address": "Aldinga, SA",
   "desc": "It looks like a home straight out of the much-loved fable The Three Little Pigs, but there is more to this house than meets the eye. The owners of the two-bedroom Aldinga residence, known as Folk Of All Trades Strawbale Home, wanted to make sure it was energy efficient, low cost and filled with natural materials when they built it. They certainly succeeded – many of the materials used to create the house are recycled and sustainable and it also has a productive garden. It has a passive solar design to regulate temperature, as well as solar, a grey water system and 35,000L rainwater tank among other eco-friendly features.",
   "imagename1": "84-1",
   "imagename2": "84-2",
   "imagename3": "84-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 85,
   "peopleid": 85,
   "title": "CLT Passivehouse Balgowlah",
   "address": "Balgowlah, NSW",
   "desc": "This two-storey extension to an existing 1920s house in Balgowlah, on Sydney’s northern beaches holds the honour of being the first certified residential Passivehouse built in cross-laminated timber (CLT) and one of only about 25 Passivehouses in Australia. The extension was designed by Betti and Knut Architecture and built by Conor Murphy in the property’s backyard, with a high quality finish to achieve the client’s request for creating a sustainable, healthy living environment for a young family. The structure was prefabricated off site, including the stair and cut-outs for lighting, power and equipment, and installed in just 15 hours. Designed to the Passivehouse standard the thermal efficiency of the building was maximised and by using mass timber a significantly reduced carbon footprint was achieved. The interior of the building features fully exposed timber walls, floors and ceilings that, in combination with the heat recovery ventilation system, provides a healthy natural indoor environment.",
   "imagename1": "85-1",
   "imagename2": "85-2",
   "imagename3": "85-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 86,
   "peopleid": 86,
   "title": "Keepin it rural",
   "address": "Hayborough, SA",
   "desc": "With a focus on sustainability and green living, Brett Aylen Architecture has created some truly unique designs across the state, with each project carefully planned to best suit its environment. Take this stunning Hayborough House which, as far as we’re concerned, for a rural home, is just like Mary Poppins – it’s practically perfect in every way. The 7.3-star home has a 5kw solar system, A Therman X Hybrid heat pump hot water system with a 300L tank, 2 5000L rainwater tanks plumbed to the house, double-glazed windows, energy-efficient LED downlights and an exposed concrete floor for thermal mass, among other passive and eco-friendly principles. It’s a home that nicely fits in with its stunning environment.",
   "imagename1": "86-1",
   "imagename2": "86-2",
   "imagename3": "86-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 87,
   "peopleid": 87,
   "title": "Recycled House",
   "address": "Redfern, NSW",
   "desc": "The family of four who live in The Recycled House, a medium-sized terrace in Redfern, use about 40 litres of mains water per day. The other 210 litres they use is rain water or grey water . It's a huge saving, as the average dwelling uses more than 600 litres of mains water every day. Other sustainable features include solar panels and a solar-hydronic floor heating system, The grey water produced in the home is cleaned by a reed-bed and reused for washing clothes, flushing toilets and watering the garden. Power consumption is reduced through the use of a 3kW Photovoltaic system, energy efficient light fixtures and fittings as well as a well-insulated concrete floor. Pictures: Anderson Architecture/Nick Bowers",
   "imagename1": "87-1",
   "imagename2": "87-2",
   "imagename3": "87-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 88,
   "peopleid": 88,
   "title": "MillBuilt Prototype",
   "address": "Yea, VIC",
   "desc": "Builder brothers Daniel and Jamie Pobjoy created this simple yet striking home as a “launching pad” for new business MillBuilt, which delivers eco-friendly homes largely made in an old Toolangi timber mill they’ve repurposed as a factory, and with a fast turnaround. Just a few weeks after they settled on the bush-side block, the fully formed three-bedroom house occupied the site. Daniel said MillBuilt would create modest homes that were “mindful of their environmental footprint”, by featuring “as much recycled timber” as possible and having energy ratings above seven stars, and ideally approaching eight soon. The Yea prototype was also packed with high-end fittings and fixtures, including stone benchtops and stainless-steel appliances, and a tiled bathroom with a freestanding tub. “Something like this, I would hope to be able to get down to three weeks (of construction) in the factory and three to five days on site,” Daniel said. The Pobjoys sold it in May for $557,250.",
   "imagename1": "88-1",
   "imagename2": "88-2",
   "imagename3": "88-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 89,
   "peopleid": 89,
   "title": "Waratah Secondary House",
   "address": "Maitland, NSW",
   "desc": "The design of this one-bedroom studio in Maitland made it possible to prioritise sustainable principles on the cheap. The box form structure known as Waratah Secondary house was built from prefabricated materials and modular components, including structurally insulated wall and roof panels. These components were selected for their superior insulation, environmental benefits, low cost and ease of installment. Designers Anthrosite Architects included big openings through double-glazed, timber doors and windows to capture or purge heat, reducing heating and cooling costs. Located in a flood prone area, the structure was elevated 1.2m off the ground to mitigate against water damage. Hard and soft landscaping, including earth mounding, were included to better connect the interior with the outdoors.",
   "imagename1": "89-1",
   "imagename2": "89-2",
   "imagename3": "89-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 90,
   "peopleid": 90,
   "title": "Handcrafted Home",
   "address": "Gold Coast, QLD",
   "desc": "This home among the trees was handcrafted from rare Australian timbers by the owner, Adrian Butcher, across .59ha in Currumbin Valley on the Gold Coast hinterland. Purpose-built for dual living, the home was designed to sympathise with the native environment by using natural building materials and incorporating expansive decking on two levels. The six-bedroom home was built eight years ago and features soaring timber ceilings to maximise natural light, complimented by glowing timber floorboards. It is currently for sale for offers above $1.495 million.",
   "imagename1": "90-1",
   "imagename2": "90-2",
   "imagename3": "90-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 91,
   "peopleid": 91,
   "title": "‘Hollywood Hills’ House",
   "address": "Donvale, VIC",
   "desc": "Style and sustainability come together at this Hollywood Hills-inspired abode in Donvale’s eco-conscious Mullum Creek development, which requires builds to have a 7.5-star energy rating. Its long list of eco credentials includes two $11,000 insulated garage doors imported from Germany, 30,000 litre water storage, a 13kW solar system, and a build made entirely of materials that are environmentally friendly and sustainably sourced. The four-bedroom house on an 1824sq m block at 3 Kern St is on the market with a $3m-$3.3m price guide — and whoever buys it will be frequently visited by kangaroos and kookaburras. The three-storey abode also features a lift, a cantilevered staircase, soaring 3.3m-high ceilings and an infinity pool.",
   "imagename1": "91-1",
   "imagename2": "91-2",
   "imagename3": "91-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 92,
   "peopleid": 92,
   "title": "Kurrajong Hill House",
   "address": "Kurrajong, NSW",
   "desc": "With straw bale walls and built with poles sourced on the property, Kurrajong Hill House is spread across two levels and has an open-plan living area and cathedral ceilings. Built on the highest part of a small cattle farm, it is entirely off the grid and relies on solar power for all electrical needs. Water is in tank storage from roof collection and grey water is treated and distributed to the orchard. Water is solar heated, while in winter it is supplemented by a wood-burner which is used for cooking. The main winter heating is through a masonry heater, which is the first of its kind in Australia. Pictures: Alan Burdon & Fiona Kotvojs",
   "imagename1": "92-1",
   "imagename2": "92-2",
   "imagename3": "92-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 93,
   "peopleid": 93,
   "title": "The Hendrie Home",
   "address": "Morphettville, SA",
   "desc": "Slick, modern living with luxe Swiss chalet appeal and an eco focus at the fore, Adelaide Green Homes delivers sustainable principles into the mainstream market. Designed for the block it sits on which faces north, the display home is angular and unconventional, but once inside it's a clear, complex layout of intersecting boxes that seem to work. The master suite is pure luxury with a two-way feature fire that also warms the living zone. Passive heating and cooling principles, correct home orientation, making the most of the winter sun via roof pitch and glazing (windows and door placement), landscaping for solar benefits, prevailing breezes and natural light principles are important factors.",
   "imagename1": "93-1",
   "imagename2": "93-2",
   "imagename3": "93-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 94,
   "peopleid": 94,
   "title": "La Fleur",
   "address": "Brisbane, QLD",
   "desc": "As far as environmental footprints go, this home is standing 'en pointe'. La Fleur is one of the most sustainable homes Queensland has ever seen and there's a 1920s Queenslander at its heart. It is designed to achieve Net Zero Energy use with Tesla Powerwall battery storage, a 13kW solar array, low-E high performance glazing, recycled concrete, 'Chain of Custody' timbers, and increased home insulation. The award haul for this Solaire Properties/Solaire Built project is impressive and the Joe Adsett-designed home is leading the charge for environmental change in the construction industry. It won best small scale development at The Urban Developer Awards in 2019 and was a finalist for the Lord Mayor's business awards for sustainability in business. Master Builders Queensland gave it the sustainability award in 2019 and it was a finalist in the HIA GreenSmart Awards QLD. Pictures: Scott Burrows, Solaire Properties",
   "imagename1": "94-1",
   "imagename2": "94-2",
   "imagename3": "94-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 95,
   "peopleid": 95,
   "title": "Rolling Ladder House",
   "address": "Canberra, ACT",
   "desc": "Light, warmth, connection to the outdoors and good social spaces are the principles underpinning the design of this house in Canberra suburb Watson. Known as the Rolling Ladder House, multiple sliding doors allow many of the spaces to be closed off when needed and the layout allows for seamless flow from indoors to out. The 181sqm home, built on the site of a previous house, has an energy efficiency rating of 8.3 stars and clever insulation cocoons the interior from the extremes of the Canberra climate. The living space is at the centre of the home – a project by 360 Building Solutions.",
   "imagename1": "95-1",
   "imagename2": "95-2",
   "imagename3": "95-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 96,
   "peopleid": 96,
   "title": "Paraparap Barn",
   "address": "Paraparap, VIC",
   "desc": "\nFamily living goes off-the-grid at an impressive Surf Coast farmhouse, which runs entirely off natural energy. Owners George Leishman and Liz Gant decided against paying $250,000 to bring power into their block from a neighbouring farm, instead arming it with a solar system. It includes batteries and a backup generator custom designed by CSR Bradford, along with a water catchment system consisting of two tanks and a dam. The couple and Geelong builders Hamlan Homes used New Zealand’s black barn-style properties as inspiration for the striking and non-traditional pad. Bespoke wall sconces made from recycled materials are featured in the bedroom, while second-hand and sustainably sourced furniture completes the eclectic offering. The working farm with livestock, hay and crops also has a pool and an outdoor entertainment area for the ultimate off-grid lifestyle. Pictures: Nikole Ramsay",
   "imagename1": "96-1",
   "imagename2": "96-2",
   "imagename3": "96-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 97,
   "peopleid": 97,
   "title": "The Food Forest Homestead Extension",
   "address": "Hillier, SA",
   "desc": "This heritage listed homestead built in 1840 is one of the oldest buildings in Hillier – which means it wasn’t built with today’s eco-friendly and sustainable standards in mind. It was dark and cold in winter and retained heat in summer but a passive solar extension built in 2000 has helped fix that. Now the old cottage has a contemporary kitchen, living and dining area, combining strawbale, stone, hollow concrete block, andwell insulated galvanised iron walls with an oxide coloured slab floor. A 22,000L rainwater tank provides water to the house and a black and grey water reed bed system cleans all wastewater, which is used to irrigate fruit trees. The house also has a 7KW solar system and is connected to the grid.",
   "imagename1": "97-1",
   "imagename2": "97-2",
   "imagename3": "97-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 98,
   "peopleid": 98,
   "title": "Kirrawee Hempcrete House",
   "address": "Kirrawee, NSW",
   "desc": "There were many considerations when building this property, including social and environmental sustainability features, accommodation for an older couple and accommodation for their adult daughter, who has a disability. The use of hempcrete in all external walls to provide thermal and acoustic insulation, recycled kitchen benches and a design that maximises the sun in winter all add to environmental features. Insulation is key to the home, with the owners only using the air conditioner on a handful of occasions since moving in. Designer: Tracy Graham — Connected Design",
   "imagename1": "98-1",
   "imagename2": "98-2",
   "imagename3": "98-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 99,
   "peopleid": 99,
   "title": "Newham Residence",
   "address": "Newham, VIC",
   "desc": "This eco-friendly haven tucked away in the Macedon Ranges offers uninterrupted views of Victoria’s famous Hanging Rock. Mark Schipano of Design Habitat created the four-bedroom family retreat using passive-design principles that minimise the home’s use of energy. The build features solar panels that work with the elements no matter the season, embracing the home’s northern orientation. Double-glazed windows allow for plenty of natural light to flood through, but also help keep the cold out – making it perfect for the wintry regional temperatures. A 110,000 litre water tank and a worm farm waste system are other environmental drawcards on the idyllic 6300sq m block. The striking timber facade is complemented by a sun-soaked deck and tranquil gardens. It last changed hands in February for $1.295m.",
   "imagename1": "99-1",
   "imagename2": "99-2",
   "imagename3": "99-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 100,
   "peopleid": 100,
   "title": "Hot in the City",
   "address": "Adelaide, SA",
   "desc": "When it comes to green living, it doesn’t come much more spectacular than this. Wining several HIA awards including 2011’s Home Of The Year and Energy Efficient Home, Mornington Rise also holds the title of being the most expensive home sold in the Adelaide Hills, fetching its seller a whopping $5.5 million. It’s clear you get one heck of an entertainer’s lifestyle with that. But that money also buys you a clean conscience, knowing you’re doing your part for the planet. This place is packed with green features, not limited to its 6-star energy rating, 10kw solar system, double-glazed Argon gas-filled windows, rammed-earth construction slow combustion heater with ample wood supply on-site and underfloor heating throughout. That’s one heck of a list!",
   "imagename1": "100-1",
   "imagename2": "100-2",
   "imagename3": "100-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 }
]

export default Data


// WEBPACK FOOTER //
// ./src/components/Data.js